module.exports = __webpack_public_path__ + "media/src/img/check-3380d932c88abeb1b4e3368dc675f6af.svg";